import {
  NAMESPACE,
  ACTIVITY_TYPE_SELECTION,
  QUIZ_ACTIVITY_COMPONENT,
} from "@modules/editor/service/editor.constant";
import { mapActions, mapGetters } from "vuex";
import EditorNavigationMixin from "@modules/editor/mixin/editor.navigation.mixin.ts";

export default {
  mixins: [EditorNavigationMixin],
  computed: {
    ...mapGetters(NAMESPACE.LESSON, ["getActivity"]),
  },
  methods: {
    ...mapActions(NAMESPACE.LESSON, [
      "setEditingComponentId",
      "setEditingContainerComponentId",
      "addNewComponent",
      "updateComponentType",
      "updateCourseCoverVisibility",
    ]),
    ...mapActions(NAMESPACE.COMPONENT, ["setEditingResourceUuid"]),
    postAddActivityHandlerEditorVersion({
      newActivityId,
      selectedActivityType,
      showAuthoringCoPilot,
    }) {
      this.goToByPageId(newActivityId, showAuthoringCoPilot).then(() => {
        switch (selectedActivityType) {
          case ACTIVITY_TYPE_SELECTION.DUPLICATE:
            break;
          case ACTIVITY_TYPE_SELECTION.BLANK:
            // go into edit mode
            if (!showAuthoringCoPilot) {
              this.setEditingComponentId(newActivityId.toString());
            }
            break;
          case ACTIVITY_TYPE_SELECTION.PRACTICE_QUIZ:
          case ACTIVITY_TYPE_SELECTION.AUTO_QUIZ:
          case ACTIVITY_TYPE_SELECTION.TEACHER_QUIZ: {
            const activity = this.getActivity(newActivityId);
            if (!showAuthoringCoPilot) {
              this.setEditingComponentId(activity.id + "_" + QUIZ_ACTIVITY_COMPONENT.QUIZ_HEADER);
              this.setEditingResourceUuid(
                activity.uuid + "_" + QUIZ_ACTIVITY_COMPONENT.QUIZ_HEADER,
              );
            }
            break;
          }
          case ACTIVITY_TYPE_SELECTION.FROM_EXISTING:
            break;
        }
      });
    },
    postAddActivityToast() {
      this.updateCourseCoverVisibility(true);
      this.$toast.show("info", {
        title: this.$i18n.t("lesson_editor_introduction_page_added_message"),
      });
    },
  },
};
